import { ColonistCoinProduct } from './ColonistCoinProduct.ts';
import { ColonistMembershipProduct } from './ColonistMembershipProduct.ts';
import { ColonistOneTimePurchaseProduct } from './ColonistOneTimePurchaseProduct.ts';
export var PaymentMethod = /*#__PURE__*/ function(PaymentMethod) {
    PaymentMethod[PaymentMethod["Stripe"] = 0] = "Stripe";
    PaymentMethod[PaymentMethod["Xsolla"] = 1] = "Xsolla";
    PaymentMethod[PaymentMethod["Discord"] = 2] = "Discord";
    PaymentMethod[PaymentMethod["None"] = 3] = "None";
    PaymentMethod[PaymentMethod["Apple"] = 4] = "Apple";
    PaymentMethod[PaymentMethod["Android"] = 5] = "Android";
    return PaymentMethod;
}({});
export var PaymentProvider = /*#__PURE__*/ function(PaymentProvider) {
    PaymentProvider[PaymentProvider["Stripe"] = 0] = "Stripe";
    PaymentProvider[PaymentProvider["Xsolla"] = 1] = "Xsolla";
    return PaymentProvider;
}({});
// persisted enum, do not delete or change existing entries
export var StoreProductType = /*#__PURE__*/ function(StoreProductType) {
    StoreProductType[StoreProductType["Coin"] = 0] = "Coin";
    StoreProductType[StoreProductType["Membership"] = 1] = "Membership";
    StoreProductType[StoreProductType["OneTimePurchase"] = 2] = "OneTimePurchase";
    return StoreProductType;
}({});
export var StripeCheckoutTypes = /*#__PURE__*/ function(StripeCheckoutTypes) {
    StripeCheckoutTypes["Payment"] = "payment";
    StripeCheckoutTypes["Subscription"] = "subscription";
    return StripeCheckoutTypes;
}({});
export function deserializeStoreProduct(storeProductType, type, itemQuantity) {
    switch(storeProductType){
        case 0:
            return ColonistCoinProduct.getPurchaseProduct(type);
        case 1:
            return ColonistMembershipProduct.getMembershipProduct(type);
        case 2:
            return ColonistOneTimePurchaseProduct.getOneTimePurchaseProduct(type, itemQuantity);
    }
}
